/**
 * @file react18MigrationHelpers.ts
 * @module _admin/helpers/react18MigrationHelpers
 * @description Provides the react18MigrationHelpers helper used for asset resolution, routing, sample data, and React compatibility support.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.3.0
 */

import { ReactNode } from "react";
import { MenuComponent } from "../assets/ts/components";

type WithChildren = {
  children?: ReactNode;
};

const reInitMenu = () => {
  setTimeout(() => {
    MenuComponent.reinitialization();
  }, 500);
};

export { type WithChildren, reInitMenu };
